import React, { useEffect } from "react";
import SmeMain from "./main";
import SmeProducts from "./products";
import WhyZikora from "./whyZikora";
import Eligibility from "./eligibility";
import AdvisorCta from "./advisorCta";
import Footer from "../../components/footer";

const Index = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ overflowX: "clip" }}>
      <SmeMain />
      <div
        style={{
          width: "100vw",
          marginLeft: "calc(50% - 50vw)",
          background:
            "linear-gradient(to bottom, #FFFFFF 0%, #F4F2EC 32%, #F4F2EC 54%, #FFFFFF 100%)",
        }}
      >
        <SmeProducts />
        <WhyZikora />
        <Eligibility />
        <AdvisorCta />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
